import { Text } from 'foundations-components/components/Text';
import { userInfoSync } from 'hub-http/userInfo';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { H5 } from 'UIComponents/elements/headings';
import { useAssetCopierContext } from '../providers/AssetCopierProvider';
import SourceToDestinationBoxes from '../common/SourceToDestinationBoxes';
import AssetsTable from '../common/AssetsTable';
import SkippedAssetsAlert from './SkippedAssetsAlert';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ConfirmSelection() {
  const {
    copyableAssets,
    selectedTargetHub
  } = useAssetCopierContext();
  const {
    portal
  } = userInfoSync();
  if (!selectedTargetHub) {
    return null;
  }
  if (copyableAssets.length === 0) {
    return /*#__PURE__*/_jsxs(Text, {
      as: "div",
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(UIIllustration, {
        name: "transactions"
      }), /*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-multi-account-asset-copier.panel.skippedAssetsAlert.titleNone"
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-multi-account-asset-copier.panel.confirmSelection.noAssetsToCopyCTA"
        })
      }), /*#__PURE__*/_jsx(SkippedAssetsAlert, {
        hideTitle: true
      })]
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "asset-copier-panel-confirm-selection",
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ui-multi-account-asset-copier.panel.confirmSelectionTitle"
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ui-multi-account-asset-copier.panel.confirmSelection.description",
      options: {
        count: copyableAssets.length,
        destinationAccountName: selectedTargetHub.name
      }
    }), /*#__PURE__*/_jsx(SkippedAssetsAlert, {}), /*#__PURE__*/_jsx(View, {
      marginBlock: "500",
      as: "div",
      children: /*#__PURE__*/_jsx(SourceToDestinationBoxes, {
        sourcePortal: {
          accountName: 'This account',
          portalId: portal.portal_id
        },
        destinationPortal: {
          accountName: selectedTargetHub.name,
          portalId: selectedTargetHub.hubId
        }
      })
    }), /*#__PURE__*/_jsx(AssetsTable, {
      assets: copyableAssets
    })]
  });
}
export default ConfirmSelection;